export default __webpack_public_path__ + "static/media/1.94a995c4.webp";